import Modal from "../../../../components/Modal"
import Notifications from "./Notifications"

/* Уведомления как bottom-sheet поверх текущей страницы (открытие с backgroundLocation) */
export default function NotificationsModal() {
    return (
        <Modal sheet>
            <div className="flex min-h-0 w-full flex-1 flex-col overflow-y-auto overscroll-contain [-webkit-overflow-scrolling:touch] px-4 sm:px-8 pb-[max(1.5rem,var(--safe-bottom))] pt-2 sm:pb-10">
                <Notifications />
            </div>
        </Modal>
    )
}
